import { render, staticRenderFns } from "./SponsorInfo.vue?vue&type=template&id=dd443cc0&"
import script from "./SponsorInfo.vue?vue&type=script&lang=js&"
export * from "./SponsorInfo.vue?vue&type=script&lang=js&"
import style0 from "./SponsorInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports